<template>
  <div>
    <Can action="view" subject="ad-manager.order">
      <AddNewOrderDialog
        :is-on="true"
        :is-loading="isAddingOrder"
        :on-cancel="onCancel"
        :on-confirm="createOrderFromDialog"
        :open-on-create="onCreated"
      />
    </Can>

    <Can action="view-business-contact" subject="ad-manager.order">
      <AddNewOrderStepper
        :promoted-deal="{}"
        :flow="flow"
        :on-cancel="onCancel"
        :on-confirm="createOrderFromStepper"
        :on-update="onCreated"
        :on-create-li="createLineItem"
        :select-on-create="onCreated"
      />
    </Can>
  </div>
</template>

<script>
  import AddNewOrderDialog from '../../components/dialog/order/AddNew';
  import AddNewOrderStepper from '../../components/steppers/Promotion';

  export default {
    components: {
      AddNewOrderDialog,
      AddNewOrderStepper,
    },
    data() {
      return {
        isAddingOrder: false,
      };
    },
    computed: {
      flow() {
        return this.$route.query.flow || '';
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'promotions' });
      },
      onCreated(order) {
        if (order?.id) {
          this.$store.dispatch('promotions/getOrders', { page: 1, archived: 0, per_page: 15 }).catch((err) => err);
          this.$router.push({ name: 'promotion-details', params: { id: order.id } });
        }
      },
      createOrderFromDialog(order) {
        this.isAddingOrder = true;

        return this.$store.dispatch('promotions/createOrder', order)
          .then(res => {
            if (res.success) {
              this.$router.push({ name: 'promotions', query: { status: 'success' } });
            }

            return res;
          })
          .catch(err => err)
          .finally(() => {
            this.isAddingOrder = false;
          });
      },
      createOrderFromStepper(order) {
        this.isAddingOrder = true;

        return this.$store.dispatch('promotions/createOrder', order)
          .then(res => res)
          .catch(err => err)
          .finally(() => {
            this.isAddingOrder = false;
          });
      },
      createLineItem(lineItem) {
        return this.$store.dispatch('promotions/createLineItem', lineItem)
          .then(res => {
            this.$store.dispatch('promotions/getOrders', { page: 1, archived: 0, per_page: 15 }).catch((err) => err);
            return res;
          });
      },
    },
  };
</script>
